/**
 * Routini API — Management
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TaxiTripRecurrenceType = {
    Daily: 'Daily',
    Weekly: 'Weekly',
    Biweekly: 'Biweekly',
    EveryThreeWeeks: 'EveryThreeWeeks',
    Monthly: 'Monthly',
    EveryXDays: 'EveryXDays'
} as const;
export type TaxiTripRecurrenceType = typeof TaxiTripRecurrenceType[keyof typeof TaxiTripRecurrenceType];

